import Vue from "vue";
import VueRouter from "vue-router";

import {
  Home,
  PageNotFound,
  Integrations,
  Integration,
  Features,
  Customers,
  Contact,
  Privacy,
} from "@/views";

Vue.use(VueRouter);

function scrollBehavior(to) {
  if (to.hash) {
    return {
      selector: to.hash,
    };
  }
}

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/integrations/:slug",
    name: "integration",
    component: Integration,
  },
  {
    path: "/integrations",
    name: "integrations",
    component: Integrations,
  },
  {
    path: "/features",
    name: "features",
    component: Features,
  },
  {
    path: "/customers",
    name: "customers",
    component: Customers,
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy,
  },
  {
    path: "*",
    name: "pageNotFound",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  scrollBehavior,
  routes,
});

export default router;
